<template lang='pug'>
  .products-index-brand-billboards
    h3.h2.brand-title.center(v-if='isMobile' v-text='entity.attributes.name')
    .brand-billboards-container.wrapped(v-if='billboards.length > 0')

      template(v-if='!isMobile')
        template(v-if='renderMultipleBillboards')
          .tabs-container
            ul.nav.nav-tabs.nav-tabs-default(role='tablist')
              li.nav-item(v-for='billboard in billboards')
                a.nav-link(:class='{ "active": billboard.id === currentBanner.id }' :href='`#billboard-${billboard.id}`' data-toggle='tab' role='tab' v-text='billboardTabTitle(billboard)' @click.prevent='displayBanner(billboard)')
          .clearfix
          .tab-content.tab-content-default
            .tab-pane(:class='{ "active": billboard.id === currentBanner.id }' role='tabpanel' :id='`billboard-${billboard.id}`' v-for='billboard in billboards' v-if='showImage(billboard.id)')
              billboard-panel(:billboard='billboard' :title='billboardTabTitle(billboard)' :show-video-image='showImage(billboard.id)')
          billboard-video(:video-id='billboard.attributes["banner-video-id"]' :video-title='billboardTabTitle(billboard)' v-if='hasVideo(billboard)' v-for='billboard in billboards' :key='billboard.attributes["banner-video-id"]')

        template(v-else)
          billboard-panel(:billboard='currentBanner' :title='billboardTabTitle(currentBanner)' :show-video-image='true')
          billboard-video(:video-id='currentBanner.attributes["banner-video-id"]' :video-title='billboardTabTitle(currentBanner)' v-if='hasVideo(currentBanner)' :key='currentBanner.attributes["banner-video-id"]')
      template(v-else)
        BillboardsCarousel(
          :billboards='mobileBillboards',
          :showArrows='false',
          :navDotsSizeClass="'sm-nav'"
        )
        .clearfix
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import BillboardsCarousel from '../../billboards/carousel.vue'
import BillboardVideo from '../../billboards/billboard-video.vue'
import BillboardPanel from '../../billboards/billboard-panel.vue'
import { languagesByCountry } from '@/modules/config/locale.js'

export default {
  components: {
    BillboardVideo,
    BillboardsCarousel,
    BillboardPanel
  },

  data () {
    return {
      currentBanner: {}
    }
  },

  computed: {
    ...mapState({
      entity: state => state.product.entity,
      billboards: state => state.product.billboards
    }),
    ...mapGetters([
      'activeCategory',
      'mobileBillboards'
    ]),
    isMobile: () => vueSupport.isMobile,
    i18nLanguage: () => I18n.language.replace('_', '-'),
    renderMultipleBillboards () {
      if (this.billboards.length === 0) {
        return false
      }
      return this.billboards.length > 1
    }
  },

  watch: {
    billboards () {
      this.currentBanner = this.billboards[0]
    }
  },

  mounted () {
    this.currentBanner = this.billboards[0]
  },

  methods: {
    billboardTabTitle (billboard) {
      if (!billboard.attributes || typeof billboard.attributes.title === 'string') {
        return this.$t('products.brand.aboutTheBrand')
      }

      let defaultLanguage = languagesByCountry[I18n.siteCountryLs].defaultLanguage

      if (defaultLanguage) {
        defaultLanguage = defaultLanguage.replace('_', '-').toLowerCase()
      }

      return billboard.attributes.title[this.i18nLanguage.toLowerCase()] || billboard.attributes.title[defaultLanguage] || this.$t('products.brand.aboutTheBrand')
    },

    displayBanner (billboard) {
      this.currentBanner = billboard
    },

    showImage (id) {
      // v-lazy does not work when component is above the fold i.e. banner with tabs
      return this.currentBanner.id === id
    },

    hasVideo (billboard) {
      if (billboard && billboard.attributes) {
        return billboard.attributes['banner-video-id']
      }
      return false
    }
  }
}
</script>

<style scoped lang='scss'>
  .products-index-brand-billboards {
    @include media-breakpoint-up(sm) {
      margin-top: 15px;
    }

    @include media-breakpoint-up(lg) {
      margin-top: 0;
    }

    .brand-title {
      @include media-breakpoint-down(sm) {
        padding-top: 10px;
        margin-bottom: 5px;
        font-size: 16px;
        letter-spacing: 1px;
        text-transform: uppercase;
      }
    }

    .nav-tabs {
      display: flex !important;
      width: 100%;
    }

    .nav-item {
      width: 100%;
    }

    .tab-content .tab-pane {
      padding: 0;
      border: 1px solid $grey;
      border-top: none;
      line-height: 0;
      position: relative;

      @include media-breakpoint-up(md) {
        min-height: 180px;
      }

      @include media-breakpoint-up(lg) {
        min-height: 245px;
      }

      @include media-breakpoint-up(xl) {
        min-height: 300px;
      }
    }

    .nav-tabs .nav-link {
      @include media-breakpoint-up(sm) {
        line-height: 33px !important;
        text-align: center;
        color: $grey-dark;
        font-size: 14px !important;
      }

      @include media-breakpoint-up(xl) {
        font-size: 13px;
      }

      &.active {
        color: $black;
      }
    }

    .brand-billboards-container {
      position: relative;

      &.wrapped {
        display: block;
        width: 100%;
        margin: 0 auto;

        @include media-breakpoint-up(md) {
          min-height: 190px;
        }

        @include media-breakpoint-up(lg) {
          min-height: 250px;
        }

        @include media-breakpoint-up(xl) {
          width: 1125px;
          margin: 20px auto;
          min-height: 300px;
        }
      }
    }
  }
</style>
